import { render, staticRenderFns } from "./FourMatText2.vue?vue&type=template&id=36c61968&scoped=true&"
var script = {}
import style0 from "./FourMatText2.vue?vue&type=style&index=0&id=36c61968&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c61968",
  null
  
)

export default component.exports